// `Symbol.matchAll` well-known symbol
require('../internals/define-well-known-symbol')('matchAll');